"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TagDto {
}
exports.TagDto = TagDto;
